type SelectionCircleProps = {
  checked: boolean;
  className?: string;
};

export function SelectionCircle({ checked, className = "" }: SelectionCircleProps) {
  return (
    <span
      aria-hidden="true"
      className={`size-5 shrink-0 rounded-full border-2 border-brand transition-colors duration-150 ${
        checked ? "bg-brand" : "bg-transparent group-hover:bg-brand/10"
      } ${className}`}
    />
  );
}
